export const PROPERTY_SEARCH_FIELDS = [
  "city",
  "state",
  "zip_code",
  "store_number",
  "country",
  "climate_zone",
  "name",
  "address",
] as const;

export function getPropertySearchTokens(input: string): string[] {
  const normalized = input
    .trim()
    .replace(/[%,()]/g, " ")
    .replace(/\s+/g, " ");

  if (!normalized) return [];

  const parts = normalized.split(" ").filter((token) => token.length >= 2);
  return (parts.length > 1 ? parts : [normalized]).slice(0, 6);
}

export function buildPropertySearchFilterForToken(token: string): string {
  return PROPERTY_SEARCH_FIELDS.map((field) => `${field}.ilike.%${token}%`).join(",");
}

export type PropertySearchGroup = {
  label: string;
  tokens: string[];
};

export function getPropertySearchGroups(input: string): PropertySearchGroup[] {
  if (!/[;,]/.test(input)) return [];

  return input
    .split(/[;,]/)
    .map((group) => group.trim())
    .filter(Boolean)
    .map((label) => ({
      label,
      tokens: getPropertySearchTokens(label),
    }))
    .filter((group) => group.tokens.length > 0);
}

export function isGroupedPropertySearch(input: string): boolean {
  return getPropertySearchGroups(input).length > 1;
}
